const IconRightArrow = () => {
  return (
    <path
      d="M3.42893 12H20.5711M20.5711 12L16.3284 16.2427M20.5711 12L16.3284 7.75738"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      data-testid="icon-right-arrow"
    />
  );
};

export default IconRightArrow;
